import { Select as AntdSelect } from 'antd'

import { InteractiveSelect, type InteractiveSelectProps } from './interactive-select'
import { ReadOnlyMultiSelect } from './read-only-multi-select'
import { ReadOnlyValueLabel } from './read-only-value-label'

export type { SelectOptionType } from './interactive-select'

export type SelectProps<ValueType> = InteractiveSelectProps<ValueType> & {
  readOnly?: boolean
}

export const Select = <ValueType,>({ readOnly, ...props }: SelectProps<ValueType>) => {
  if (readOnly && props.mode === 'multiple') return <ReadOnlyMultiSelect {...props} />
  if (readOnly) return <ReadOnlyValueLabel {...props} />
  return <InteractiveSelect {...props} />
}

Select.Option = AntdSelect.Option
Select.OptGroup = AntdSelect.OptGroup
